module.exports = __webpack_public_path__ + "static/media/dissat.89fcfd0c.svg";